var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.6375 19.4375C32.5608 14.0469 27.7633 10 22 10C17.4242 10 13.45 12.5625 11.4708 16.3125C6.705 16.8125 3 20.7969 3 25.625C3 30.7969 7.25917 35 12.5 35H33.0833C37.4533 35 41 31.5 41 27.1875C41 23.0625 37.7542 19.7188 33.6375 19.4375ZM33.0833 31.875H12.5C9.00083 31.875 6.16667 29.0781 6.16667 25.625C6.16667 22.1719 9.00083 19.375 12.5 19.375H13.6242C14.6692 15.7656 18.01 13.125 22 13.125C26.8133 13.125 30.7083 16.9688 30.7083 21.7188V22.5H33.0833C35.7117 22.5 37.8333 24.5938 37.8333 27.1875C37.8333 29.7812 35.7117 31.875 33.0833 31.875Z","fill":"#5B59FB"}));
}

Cloud.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Cloud;

Cloud.default = Cloud;
